module.exports = __webpack_public_path__ + "img/footer_logo_CN.874753cf.png";